/* =========================================================================
 * LST6 DIRECT BUY  core v2 (post-review Codex 2026-08-08, 12 findings appliques)
 * State model + cart adapter partages par les 5 mockups.
 * Portage Liquid : devient assets/lst6-direct-buy.js tel quel.
 * Donnees produit : <script type="application/json" data-lst-product>
 * (en Liquid : {{ product | json }} filtre  jamais d'ID/prix en dur ici).
 * Reentrance : controleur par racine [data-lst6-root], init idempotente,
 * destroy() + AbortController  brancher sur shopify:section:load/unload.
 * ========================================================================= */
(function () {
  'use strict';

  var MOCK = false; // prod : toujours le vrai panier Shopify

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function uid() { return 'lst6-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- cart adapter (Shrine) ---------- */
  var CartAdapter = {
    root: (window.Shopify && Shopify.routes && Shopify.routes.root) || '/',

    _url: function (path) { return this.root.replace(/\/$/, '') + path; },

    /* GET cart.js  tolere les reponses HTML (429) avec un retry doux */
    getCart: function (attempt) {
      var self = this;
      return fetch(this._url('/cart.js')).then(function (res) {
        if (res.status === 429 && !attempt) return sleep(2000).then(function () { return self.getCart(1); });
        return res.text().then(function (t) {
          try { return JSON.parse(t); } catch (e) { throw new Error('CART_READ_FAILED'); }
        });
      });
    },

    /* stricte : une erreur de lecture N'EST PAS "absent"  elle se propage
     * (CART_READ_FAILED) et l'appelant doit traiter l'etat comme INCONNU. */
    bundleInCart: function (bundleId) {
      return this.getCart().then(function (cart) {
        return cart.items.some(function (i) { return i.properties && i.properties._lst_bundle_id === bundleId; });
      });
    },

    /* POST add  JAMAIS de re-POST aveugle (exigence review) :
     * sur 429/erreur reseau/reponse ambigue  attendre, VERIFIER si le bundle
     * est deja en panier (le 1er POST a pu passer), et ne re-POSTer qu'une
     * seule fois s'il est reellement absent. */
    add: function (items, bundleId) {
      var self = this;
      var payload = JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' });
      function post() {
        return fetch(self._url('/cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload
        });
      }
      function parse(res) {
        return res.text().then(function (t) {
          var j = null; try { j = JSON.parse(t); } catch (e) {}
          return { status: res.status, ok: res.ok, json: j };
        });
      }
      return post().then(parse).catch(function () { return { status: 0, ok: false, json: null }; })
        .then(function (r) {
          if (r.ok && r.json) return r.json;
          /* echec ou ambigu  le 1er add a-t-il porte ? Lecture STRICTE :
           * si le panier est illisible, l'etat est INCONNU  jamais de re-POST. */
          return sleep(r.status === 429 ? 2500 : 1200).then(function () {
            return self.bundleInCart(bundleId)
              .catch(function () { throw new Error('CART_STATE_UNKNOWN'); })
              .then(function (present) {
                if (present) return { items: items, sections: null, _recovered: true };
                if (r.status === 429 || r.status === 0) {
                  /* bundle reellement absent  UN SEUL re-POST, toujours re-verifie */
                  return post().then(parse).catch(function () { return { status: 0, ok: false, json: null }; })
                    .then(function (r2) {
                      if (r2.ok && r2.json) return r2.json;
                      return self.bundleInCart(bundleId)
                        .catch(function () { throw new Error('CART_STATE_UNKNOWN'); })
                        .then(function (p2) {
                          if (p2) return { items: items, sections: null, _recovered: true };
                          throw new Error((r2.json && r2.json.description) || 'ADD_FAILED');
                        });
                    });
                }
                throw new Error((r.json && r.json.description) || 'ADD_FAILED');
              });
          });
        });
    },

    /* Verification niveau PANIER ENTIER (teste 2026-08-08, panier contamine) :
     * le discount automatique se recalcule sur toutes les unites du produit 
     * la ligne offerte peut etre une ligne SANS properties. Regle boutique
     * observee : 1 unite offerte pour 2 unites au panier  floor(total/2).
     * freeUnits par ligne = unites remisees a 100 % :
     * (original_line_price - final_line_price) / price  (un seul signal, pas
     * de double comptage  finding #2). */
    verifyCart: function (expected) {
      return this.getCart().then(function (cart) {
        var bundleLines = cart.items.filter(function (i) {
          return i.properties && i.properties._lst_bundle_id === expected.bundleId;
        });
        var bundleUnits = bundleLines.reduce(function (s, i) { return s + i.quantity; }, 0);
        var productLines = cart.items.filter(function (i) { return i.product_id === expected.productId; });
        var totalUnits = productLines.reduce(function (s, i) { return s + i.quantity; }, 0);
        var freeUnits = productLines.reduce(function (s, i) {
          var op = (typeof i.original_line_price === 'number') ? i.original_line_price : i.price * i.quantity;
          var fp = (typeof i.final_line_price === 'number') ? i.final_line_price : op;
          return s + Math.round((op - fp) / i.price);
        }, 0);
        var expectedFree = Math.floor(totalUnits / 2);
        return {
          ok: bundleUnits === expected.units && (expectedFree === 0 || freeUnits >= expectedFree),
          units: bundleUnits, freeUnits: freeUnits, expectedFree: expectedFree,
          totalUnits: totalUnits, cart: cart, lines: bundleLines
        };
      });
    },

    /* rollback verifie (finding #6) : re-GET apres update, residu  ROLLBACK_FAILED.
     * TOUTE erreur (reseau, lecture, TypeError) est normalisee en ROLLBACK_FAILED :
     * un rollback a l'etat indetermine doit TOUJOURS declencher le verrouillage
     * cote appelant, jamais une erreur retriable (passe 3 review). */
    rollbackBundle: function (bundleId) {
      var self = this;
      return this.getCart().then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) {
          if (i.properties && i.properties._lst_bundle_id === bundleId) updates[i.key] = 0;
        });
        if (!Object.keys(updates).length) return true;
        return fetch(self._url('/cart/update.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error('ROLLBACK_FAILED');
          return self.bundleInCart(bundleId).then(function (still) {
            if (still) throw new Error('ROLLBACK_FAILED');
            return true;
          });
        });
      }).catch(function () { throw new Error('ROLLBACK_FAILED'); });
    },

    setAttribution: function (source) {
      return fetch(this._url('/cart/update.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { lst_source: source } })
      }).catch(function () { /* best-effort : ne bloque jamais l'achat */ });
    },

    /* rendu drawer isole (finding #5) : une erreur ici ne doit JAMAIS etre
     * presentee comme un echec d'achat  fallback /cart silencieux. */
    renderDrawer: function (addResponse) {
      var self = this;
      var drawer = document.querySelector('cart-drawer');
      function paint(resp) {
        try {
          if (drawer && typeof drawer.renderContents === 'function' && resp && resp.sections) {
            drawer.renderContents(resp);
            /* le theme pose is-empty au chargement (panier vide) et renderContents ne
               re-rend pas la racine : sans ce retrait le CSS masque tout -> tiroir blanc */
            drawer.classList.remove('is-empty');
            var di = drawer.querySelector('.drawer__inner'); if (di) di.classList.remove('is-empty');
            return true;
          }
        } catch (e) {}
        return false;
      }
      if (paint(addResponse)) return true;
      if (drawer) {
        /* recovery path (429/retry): refetch drawer sections instead of leaving the page */
        return fetch(self._url('/?sections=cart-drawer,cart-icon-bubble'))
          .then(function (r) { return r.json(); })
          .then(function (sections) { if (!paint({ sections: sections })) throw 0; return true; })
          .catch(function () {
            /* sections illisibles (ex: 429 HTML) : ne JAMAIS quitter la page.
               L'item EST au panier -> ouvrir le tiroir tel quel, retenter le render apres. */
            try { if (typeof drawer.open === 'function') drawer.open(); else { drawer.classList.add('active', 'animate'); } } catch (e) {}
            setTimeout(function () {
              fetch(self._url('/?sections=cart-drawer,cart-icon-bubble'))
                .then(function (r) { return r.json(); })
                .then(function (sections) { paint({ sections: sections }); })
                .catch(function () {});
            }, 1800);
            return true;
          });
      }
      return false;
    }
  };

  /* echappement HTML : les titres de variantes/offres passent par innerHTML */
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- state model ---------- */
  /* OFFERS : construit a l'init depuis le DOM (blocks Liquid de la section buy) 
   * chaque [data-lst-offer-id] porte data-lst-offer-qty (unites totales postees)
   * et data-lst-offer-free (unites offertes attendues). */
  var OFFERS = {};
  function buildOffers(root) {
    OFFERS = {};
    (root || document).querySelectorAll('[data-lst-offer-id]').forEach(function (el) {
      var id = el.getAttribute('data-lst-offer-id');
      OFFERS[id] = {
        id: id,
        label: (el.querySelector('.lst6-offer__title') || {}).textContent || id,
        slots: Number(el.getAttribute('data-lst-offer-qty')) || 1,
        freeUnits: Number(el.getAttribute('data-lst-offer-free')) || 0,
        defaults: (el.getAttribute('data-lst-default-variants') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean)
      };
    });
  }

  var LST6 = window.LST6 = {
    esc: esc,
    OFFERS: OFFERS,
    product: null,
    state: { offerId: null, slots: [], pending: false, locked: false, bundleId: null },
    _listeners: {},
    _uiFns: [],
    _abort: null,
    _inited: false,

    init: function (rootEl) {
      /* garde mono-root (review 2026-08-08) : 1 module achat par page, par design.
       * Un 2e root est ignore (le 1er gagne) pour eviter les etats croises. */
      if (this._inited && rootEl && this.rootEl && rootEl !== this.rootEl) return;
      if (this._inited) this.destroy();
      var dataEl = document.querySelector('script[data-lst-product]');
      if (!dataEl) throw new Error('LST6: donnees produit absentes');
      this.product = JSON.parse(dataEl.textContent);
      this.rootEl = rootEl && rootEl.querySelector ? rootEl : document;
      this._abort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      this._inited = true;
      buildOffers(this.rootEl);
      LST6.OFFERS = OFFERS;
      var pre = this.rootEl.querySelector('[data-lst-action="select-offer"][data-selected]');
      if (!pre) pre = this.rootEl.querySelector('[data-lst-offer-id]');
      this.bind();
      /* le wiring UI (renderers des pages) se re-enregistre a CHAQUE init */
      var self = this;
      this._uiFns.forEach(function (fn) { try { fn(self); } catch (e) {} });
      if (pre) this.setOffer(pre.getAttribute('data-lst-offer-id'));
    },

    /* les pages enregistrent leur wiring ici : rejoue apres chaque init
     * (Theme Editor shopify:section:load). fn recoit LST6 ; les listeners
     * DOM du wiring DOIVENT utiliser LST6.signal() pour etre abortes. */
    registerUI: function (fn) {
      this._uiFns.push(fn);
      if (this._inited) { try { fn(this); } catch (e) {} }
    },

    signal: function () { return this._abort ? { signal: this._abort.signal } : false; },

    destroy: function () {
      if (this._abort) this._abort.abort();
      this._listeners = {};
      this._inited = false;
      /* reset complet du state (review finale) : sans lui, un re-init avec un autre
       * produit garderait les anciens variantIds (no-op setOffer) -> ATC du mauvais produit */
      this.state = { offerId: null, slots: [], pending: false, locked: false, bundleId: null };
      this.product = null;
      this.rootEl = null;
    },

    on: function (evt, fn) { (this._listeners[evt] = this._listeners[evt] || []).push(fn); },
    emit: function (evt, detail) {
      (this._listeners[evt] || []).forEach(function (fn) { try { fn(detail); } catch (e) {} });
      document.dispatchEvent(new CustomEvent('lst6:' + evt, { detail: detail }));
    },

    setOffer: function (offerId) {
      if (this.state.pending) return;
      var offer = OFFERS[offerId];
      if (!offer) return;
      /* no-op si deja selectionnee ET slots construits  sinon un clic dans le
       * dropdown de coloris (qui bulle vers l'offre) re-rendrait les slots et
       * refermerait le dropdown (bug detecte E2E 2026-08-08) */
      if (offerId === this.state.offerId && this.state.slots.length === offer.slots) return;
      this.state.offerId = offerId;
      if (!this.product || !this.product.variants || !this.product.variants.length) return;
      var avail = this.product.variants.filter(function (v) { return v.available !== false; });
      if (!avail.length) {
        /* tout est sold out : pas de variante par defaut posable -> CTA off, pas de 422 */
        this.state.soldOut = true;
        this.state.slots = [];
        var so = document.querySelector('[data-lst-action="add-to-cart"]');
        if (so) { so.disabled = true; so.textContent = 'Sold out'; }
        this.emit('offer-change', { offerId: offerId, slots: 0 });
        return;
      }
      this.state.soldOut = false;
      var defVariant = avail[0].id;
      var byName = {};
      avail.forEach(function (v) { byName[v.title.toLowerCase()] = v.id; });
      var prev = this.state.slots;
      this.state.slots = [];
      for (var i = 0; i < offer.slots; i++) {
        var wanted = offer.defaults && offer.defaults[i] ? byName[offer.defaults[i].toLowerCase()] : null;
        this.state.slots.push({ variantId: wanted || (prev[i] && prev[i].variantId) || defVariant });
      }
      this.emit('offer-change', { offerId: offerId, slots: this.state.slots.length });
    },

    setSlotVariant: function (slotIdx, variantId) {
      if (this.state.pending) return;
      if (!this.state.slots[slotIdx]) return;
      this.state.slots[slotIdx].variantId = Number(variantId);
      this.emit('slot-change', { slot: slotIdx, variantId: Number(variantId) });
    },

    pricing: function () {
      var offer = OFFERS[this.state.offerId];
      var unit = this.product.price;
      return { compare: unit * offer.slots, pay: unit * (offer.slots - offer.freeUnits),
               save: unit * offer.freeUnits, units: offer.slots };
    },

    addToCart: function () {
      var self = this;
      if (this.state.pending) return Promise.reject(new Error('ADD_PENDING'));
      if (this.state.locked) return Promise.reject(new Error('CART_LOCKED'));
      if (this.state.soldOut || !this.state.slots.length) return Promise.reject(new Error('SOLD_OUT'));
      var offer = OFFERS[this.state.offerId];
      /* snapshot immuable (finding #10) : l'offre/slots au moment du clic */
      var slots = this.state.slots.map(function (s) { return { variantId: s.variantId }; });
      var bundleId = uid();
      this.state.pending = true;
      this.state.bundleId = bundleId;
      this.emit('add-start', { bundleId: bundleId });

      var byVariant = {};
      slots.forEach(function (s) { byVariant[s.variantId] = (byVariant[s.variantId] || 0) + 1; });
      var items = Object.keys(byVariant).map(function (vid) {
        return { id: Number(vid), quantity: byVariant[vid],
                 properties: { _lst_source: self.product.lstSource, _lst_bundle_id: bundleId, _lst_offer: offer.id } };
      });

      function lockCart() {
        self.state.locked = true;
        self.emit('cart-locked', { bundleId: bundleId });
        CartAdapter.renderDrawer(null); // montrer le panier reel, jamais de retry
      }
      var pre = Promise.resolve();
      if (this.rootEl && (this.rootEl.hasAttribute('data-lst-clear-cart') || this.rootEl.querySelector('[data-lst-clear-cart]'))) {
        /* option: empty the cart in ONE request before adding (perf mobile) */
        pre = fetch(CartAdapter._url('/cart/clear.js'), { method: 'POST' }).then(function (r) {
          if (!r.ok) throw new Error('CLEAR_FAILED');
        });
      }
      return pre.then(function () { return CartAdapter.add(items, bundleId); })
        .then(function (addResponse) {
          return CartAdapter.verifyCart({ bundleId: bundleId, units: offer.slots, productId: self.product.productId })
            .catch(function () {
              /* verify illisible (429 frequents en preview) MAIS l'add a repondu OK :
               * l'ajout est certain, la gratuite est appliquee cote serveur (prouve).
               * -> on considere OK au lieu de verrouiller la page.
               * Verrouillage reserve aux ajouts AMBIGUS (chemin _recovered). */
              if (addResponse && !addResponse._recovered) {
                return { ok: true, unverified: true, cart: null, lines: [] };
              }
              lockCart();
              throw new Error('CART_STATE_UNKNOWN');
            })
            .then(function (verdict) {
              if (!verdict.ok) {
                return CartAdapter.rollbackBundle(bundleId)
                  .then(function () { throw new Error('OFFER_NOT_APPLIED'); })
                  .catch(function (e) {
                    if (e.message === 'ROLLBACK_FAILED' || e.message === 'CART_READ_FAILED') {
                      /* residu OU etat inverifiable : verrouiller, montrer le panier reel */
                      lockCart();
                      throw new Error('ROLLBACK_FAILED');
                    }
                    throw e;
                  });
              }
              /* succes verifie : plus AUCUN add-error possible apres ce point */
              CartAdapter.setAttribution(self.product.lstSource);
              self.emit('add-success', { bundleId: bundleId, verdict: verdict, itemCount: verdict.cart ? verdict.cart.item_count : null });
              CartAdapter.renderDrawer(addResponse); // isole  ne throw jamais
              return verdict;
            });
        })
        .catch(function (err) {
          if (err.message === 'CART_STATE_UNKNOWN' && !self.state.locked) lockCart();
          if (err.message !== 'ROLLBACK_FAILED' && err.message !== 'CART_STATE_UNKNOWN') {
            self.emit('add-error', { message: err.message });
          }
          throw err;
        })
        .finally(function () { self.state.pending = false; });
    },

    bind: function () {
      var self = this;
      var opts = this._abort ? { signal: this._abort.signal } : false;
      this.rootEl.addEventListener('click', function (e) {
        var t = e.target.closest('[data-lst-action]');
        if (!t) return;
        var action = t.getAttribute('data-lst-action');
        if (action === 'select-offer') {
          e.preventDefault();
          self.setOffer(t.getAttribute('data-lst-offer-id'));
        } else if (action === 'add-to-cart') {
          e.preventDefault();
          self._uiBusy(true, t);
          self.addToCart()
            .then(function () { t.setAttribute('data-lst-status', 'done'); })
            .catch(function (err) {
              if (err.message === 'ADD_PENDING') return; // ignore proprement (finding #10)
              t.setAttribute('data-lst-status', 'error');
            })
            .finally(function () {
              self._uiBusy(false, t);
              setTimeout(function () { if (!self.state.locked) t.removeAttribute('data-lst-status'); }, 2500);
            });
        } else if (action === 'scroll-to-buy') {
          var target = document.querySelector('[data-lst-slot="buy-block"]');
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        } else if (action === 'close-drawer') {
          var d = document.querySelector('[data-lst-mock-drawer]');
          if (d) { d.removeAttribute('open'); document.documentElement.classList.remove('lst6-drawer-open'); }
        }
      }, opts);
      this.rootEl.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-lst-action="select-variant"]');
        if (sel) self.setSlotVariant(Number(sel.getAttribute('data-lst-slot-index')), sel.value);
      }, opts);
      /* bfcache : au retour arriere, deverrouiller l'UI si l'etat est sain */
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) { self.state.pending = false; self.emit('offer-change', { offerId: self.state.offerId }); }
      }, opts);
    },

    _uiBusy: function (busy, cta) {
      if (cta) {
        if (busy) { cta.setAttribute('data-lst-status', 'pending'); cta.setAttribute('aria-busy', 'true'); cta.disabled = true; }
        else { cta.removeAttribute('aria-busy'); cta.disabled = this.state.locked; }
      }
      this.rootEl.querySelectorAll('[data-lst-action="select-offer"], [data-lst-action="select-variant"]')
        .forEach(function (el) {
          if (el.tagName === 'SELECT' || el.tagName === 'BUTTON') el.disabled = busy;
          el.setAttribute('aria-disabled', busy ? 'true' : 'false');
        });
    }
  };
})();

/* ---------- wiring UI (renderers)  auto-enregistre ---------- */
LST6.registerUI(function(L){
  var esc = L.esc; /* esc() vit dans l'IIFE du module, exposee sur l'objet */
  /* le CTA custom est rendu disabled dans le Liquid (page morte si cet asset ne
     charge pas) : on ne l'active qu'ici, une fois le module reellement boot. */
  (function(){ var c=document.querySelector('[data-lst-action="add-to-cart"]');
    if(c && !L.state.soldOut){ c.disabled=false; } })();
  function money(c){return '$'+(c/100).toFixed(2);}
  function renderSlots(){
    // vider tous les conteneurs, remplir celui de l'offre selectionnee (accordeon Kaching)
    document.querySelectorAll('[data-lst-offer-slots]').forEach(function(w){w.innerHTML='';});
    var wrap=document.querySelector('[data-lst-offer-slots="'+LST6.state.offerId+'"]'); if(!wrap) return;
    var rows=LST6.state.slots.map(function(s,i){
      var opts=LST6.product.variants.map(function(v){
        return '<option value="'+v.id+'"'+(v.id===s.variantId?' selected':'')+'>'+esc(v.title)+'</option>';}).join('');
      var v=LST6.product.variants.find(function(x){return x.id===s.variantId;});
      var opts2=LST6.product.variants.map(function(x){
        return '<button type="button" class="lst6-dd__opt'+(x.id===s.variantId?' is-on':'')+'"'+(x.available===false?' disabled':'')+' data-lst-swatch data-lst-slot-index="'+i+'" data-variant-id="'+x.id+'"><img src="'+esc(x.swatch||x.image)+'" alt=""><span>'+esc(x.title)+(x.available===false?' (sold out)':'')+'</span></button>';}).join('');
      return '<div class="lst6-vrow"><span class="lst6-vrow__num">#'+(i+1)+'</span>'+
        '<div class="lst6-dd" data-lst-dd>'+
        '<button type="button" class="lst6-dd__btn" data-lst-dd-toggle aria-haspopup="listbox">'+
        '<img src="'+esc(v?(v.swatch||v.image):'')+'" alt=""><span>'+esc(v?v.title:'')+'</span>'+
        '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button>'+
        '<div class="lst6-dd__list" role="listbox">'+opts2+'</div></div></div>';
    }).join('');
    wrap.innerHTML='<div class="lst6-offer__variants-label">Color</div>'+rows;
  }
  function renderPrices(){
    var p=LST6.pricing();
    var el=document.querySelector('[data-lst-slot="cta-price"]');
    if(el) el.innerHTML=(p.save>0?'<s style="opacity:.7">'+money(p.compare)+'</s> ':'')+money(p.pay);
    var sp=document.querySelector('[data-lst-slot="sticky-price"]');
    if(sp) sp.textContent=money(p.pay);
    document.querySelectorAll('[data-lst-action="select-offer"]').forEach(function(o){
      var sel=o.getAttribute('data-lst-offer-id')===LST6.state.offerId;
      if(sel) o.setAttribute('data-selected',''); else o.removeAttribute('data-selected');
      o.setAttribute('aria-checked', sel?'true':'false');
    });
    // steps (mockup E) : progression consommee
    document.querySelectorAll('[data-lst-step]').forEach(function(st){
      st.setAttribute('data-lst-step-state','done');
    });
    var recap=document.querySelector('[data-lst-slot="recap"]');
    if(recap){
      var offer=LST6.OFFERS[LST6.state.offerId];
      var names=LST6.state.slots.map(function(s){var v=LST6.product.variants.find(function(x){return x.id===s.variantId;});return v?v.title:'';});
      recap.innerHTML='<strong>'+esc(offer.label)+'</strong> \u2014 '+names.map(esc).join(' + ')+'<br>You pay <strong>'+money(p.pay)+'</strong>'+(p.save>0?' \u00b7 you save <strong>'+money(p.save)+'</strong>':'');
    }
  }
  function renderAll(){renderSlots();renderPrices();}
  L.on('offer-change',renderAll);
  L.on('slot-change',renderAll);
  L.on('add-error',function(d){
    var e=document.querySelector('[data-lst-slot="error"]');
    if(e){e.textContent=(d.message==='OFFER_NOT_APPLIED')?
      "The free-item offer couldn't be applied ' nothing was charged. Please try again or contact support.":
      "Something went wrong adding to cart. Please try again.";
      e.classList.add('is-visible'); setTimeout(function(){e.classList.remove('is-visible');},6000);}
  });
  L.on('cart-locked',function(){
    var e=document.querySelector('[data-lst-slot="error"]');
    if(e){e.textContent="We couldn't confirm your cart - please review it before ordering. Your card was NOT charged.";
      e.classList.add('is-visible');}
    var cta=document.querySelector('[data-lst-action="add-to-cart"]');
    if(cta){cta.disabled=true;cta.setAttribute('data-lst-status','error');}
  });
  // dropdown coloris custom (capture Alex)
  document.addEventListener('click',function(e){
    var opt=e.target.closest('[data-lst-swatch]');
    if(opt){ LST6.setSlotVariant(Number(opt.getAttribute('data-lst-slot-index')), opt.getAttribute('data-variant-id')); return; }
    var tg=e.target.closest('[data-lst-dd-toggle]');
    if(tg){ var dd=tg.closest('[data-lst-dd]'); var was=dd.classList.contains('is-open');
      document.querySelectorAll('[data-lst-dd].is-open').forEach(function(x){x.classList.remove('is-open');});
      if(!was) dd.classList.add('is-open'); return; }
    document.querySelectorAll('[data-lst-dd].is-open').forEach(function(x){x.classList.remove('is-open');});
  },L.signal());
  // galerie (aborte au destroy via L.signal())
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-lst-gallery-thumb]'); if(!t) return;
    var main=document.querySelector('[data-lst-gallery-main]'); if(main) main.src=t.src.replace('width=200','width=800');
    document.querySelectorAll('[data-lst-gallery-thumb]').forEach(function(x){x.classList.toggle('is-active',x===t);});
  },L.signal());
  // sticky bar
  var sticky=document.querySelector('[data-lst-slot="sticky-bar"]');
  if(sticky){
    var buy=document.querySelector('[data-lst-slot="buy-block"]');
    var opts=L.signal(); if(opts) opts.passive=true; else opts={passive:true};
    window.addEventListener('scroll',function(){
      var pastHero=window.scrollY>500;
      var buyVisible=buy&&buy.getBoundingClientRect().top<window.innerHeight;
      sticky.classList.toggle('is-visible',pastHero&&!buyVisible);
    },opts);
  }
  renderAll();
});
